import request from "@/utils/request";
import { getAuthorizationHeader } from ".";

export async function signUp(data) {
  const response = await request.post("/customers/sign-up", data);
  return response.data.data;
}

export async function signIn(data) {
  const response = await request.post("/customers/sign-in", data);
  return response.data.data;
}

export async function getMe() {
  const response = await request.get("/customers/me", getAuthorizationHeader());
  return response.data.data;
}

export async function getTotalPoints() {
  const response = await request.get("/customers/me/points/total", getAuthorizationHeader());
  return response.data.data;
}

export async function getPointTransactions(page, size, filter) {
  const response = await request.get(
    `/customers/me/points?page=${page}&size=${size}&filter=${JSON.stringify(filter)}`,
    getAuthorizationHeader()
  );
  return response.data.data;
}

export async function sendVerificationCode(phone) {
  const response = await request.post('/customers/verify-reset-password', { phone });
  return response.data.data;
}

export async function resetPassword(passwordReset) {
  await request.post('/customers/reset-password', passwordReset);
}